import React, { Component, Fragment, useState, useEffect, useRef  } from 'react';
import {withRouter} from 'react-router-dom';
import moment from 'moment';
import "rc-switch/assets/index.css";

import 'video-react/dist/video-react.css';

import {Button, Row, Col, Table, Card, CardBody, CardTitle, CardText} from 'reactstrap';

import AppLayout from '../../components/AppLayout';

import ModalPowerpoint from '../../components/training/ModalPowerpoint';
import ModalQuiz from '../../components/training/ModalQuiz';
import apiClient from '../../apiClient';

const Training = ({
    user, authButtonMethod, isAuthenticated, promptUserLocation, selectUserLocation, setUserLocation, saveUserLocation, launchModalChangeLocation, displaySubmenu, handleDisplaySubmenu, eightyWindow, width
}) => {

    const [i_training_id, set_i_training_id] = useState(null);
    const [assignedContent, setAssignedContent] = useState([]);
    const [trainingRecord, setTrainingRecords] = useState([]);
    const [trainingContent, setTrainingContent] = useState([]); 
    const [modalPowerpointOpen, setModalPowerpointOpen] = useState(false);
    const [powerpointLink, setPowerpointLink] = useState('');
    const [modalQuizOpen, setModalQuizOpen] = useState(false);
    const [i_quiz_id, set_i_quiz_id] = useState(null);
    const [selectedContent, setSelectedContent] = useState(null);
    const [s_access_type, set_s_access_type] = useState('');
    const [assignorName, setAssignorName] = useState('');
    
    const selectTrainingAssigned = () => {
        const data = {
            s_user_id: user && user.s_email
        }
        apiClient.post(`/selectTrainingAssigned`, {
            data
        }).then(response => {
            if (response.data) {

                const {trainingAssigned, trainingRecords, assignorName} = response.data;
                setAssignedContent(trainingAssigned);
                setTrainingRecords(trainingRecords);
                setAssignorName(assignorName);

                setTrainingContent(trainingAssigned);    
                if (trainingAssigned) {
                    set_s_access_type(trainingAssigned[0].s_access_type)
                }
   
            }
        }).catch(error => {
            console.log(error);
        });
    }

    useEffect(() => {
        if (user.s_email) {
            selectTrainingAssigned();
        }
    }, [user.s_email]);

    const resolveCompleted = (content, records) => {
        for (let i = 0; i < content.length; i++) {
            if (records && records.length > 0) {
                const match = records.filter(r => r.i_content_id === content[i].i_content_id);
                if (match.length > 0) {
                    const useRecord = match[match.length - 1];
                    content[i].b_completed = useRecord.b_completed;
                    content[i].t_completed = useRecord.t_completed;
                    content[i].f_percent = useRecord.f_percent;
                }
            }
        }
 
        return content;
    }

    const createTrainingRecord = (content, quiz=false, quizContent=null) => {
        const now = moment().local().format('MM/DD/YYYY hh:mm A');

        const data = {
            quiz,
            main: {
                i_content_id: content.i_content_id,
                s_user_id: user && user.s_email,
                b_completed: quiz ? quizContent.b_completed : true,
                t_completed: now,
                i_training_id: content.i_training_id,
                s_unit: user && user.s_unit,
                s_assignor: content.s_assignor,
                i_training_assigned_id: content.id
            },
            other: {}
        }

        if (quiz) {
            const {i_score, i_total, s_instructor, s_quiz_html} = quizContent;
            data.main.i_score = i_score;
            data.main.i_total = i_total;
            data.main.s_instructor = assignorName;
            data.other.s_quiz_html = s_quiz_html;
        }

        apiClient.post(`/createTrainingRecord`, {
            data
        }).then(response => {
            const {trainingAssigned, trainingRecords} = response.data;
            setAssignedContent(trainingAssigned);
            setTrainingRecords(trainingRecords);

            // setTrainingContent(resolveCompleted(trainingAssigned, trainingRecords));
            
            setTrainingContent(trainingAssigned);    
            if (trainingAssigned) {
                set_s_access_type(trainingAssigned[0].s_access_type)
            }
        }).catch(error => {

        });
    }

    // const enableQuiz = () => {
    //     let allWatched = true;

    //     for (let i = 0; i < trainingVideos.length; i++) {
    //         if (!trainingVideos[i].b_watched) {
    //             allWatched = false;
    //         }
    //     }

    //     for (let i = 0; i < trainingPowerpoints.lenght; i++) {
    //         if (!trainingPowerpoints[i].b_watched) {
    //             allWatched = false;
    //         }   
    //     }

    //     return allWatched;
    // }

    const enableStartContent = (content) => {
        // console.log(`Content order = ${order}`);
        if (content.s_type === 'POWERPOINT') {
            return true;
        }
        // console.log(trainingContent);
        // console.log(assignedContent);
        // console.log(assignedContent[order - 1]);
        const contentPowerpoint = assignedContent.find(c => c.id === content.id && c.s_type === 'POWERPOINT');
        return contentPowerpoint && contentPowerpoint.b_completed;
    }

    const openContent = (content) => {
        set_i_training_id(content.i_training_id);
        setSelectedContent(content);
        if (content.s_type.toUpperCase() === 'POWERPOINT') {
            setPowerpointLink(content.s_link);
            setModalPowerpointOpen(true);
            // if (!content.b_completed && content.s_access_type !== 'BOTH') {
            //     // 12/30/2024: Disabling creating records for quizzes
            //     createTrainingRecord(content);
            // }
            if (!content.b_completed) {
                createTrainingRecord(content);
            }
        } else if (content.s_type.toUpperCase() === 'QUIZ') {
            set_i_quiz_id(content.i_quiz_id);
            setModalQuizOpen(true);
        }
    }

    const handleContent = (content) => {
        if (content.b_enforce_content) {
            if (enableStartContent(content)) {
                openContent(content);
            } else {
                alert('You must finish all previous training Content before taking the quiz.');
            }    
        } else {
            openContent(content);
        }
    }

    const accessMapping = (s_access_type, trainingContent) => {

        const mapping = [];

        if (s_access_type === 'QUIZ') {
            trainingContent.map(t => t.s_type === 'QUIZ' && mapping.push(t));
        } else if (s_access_type === 'CONTENT') {
            trainingContent.map(t => t.s_type !== 'QUIZ' && mapping.push(t));
        } else {
            trainingContent.map(t => mapping.push(t));
        }
        return mapping;
    }

    const resolveTrainingMapping = (trainingContent) => {

        const mappedByModuleId = [];

        for (let i = 0; i < trainingContent.length; i++) {
            const searchModuleId = trainingContent[i].i_training_id;
            const found = mappedByModuleId.find(t => t.id === searchModuleId);
            if (found) {
                for (let j = 0; j < mappedByModuleId.length; j++) {
                    if (mappedByModuleId[j].id === searchModuleId) {
                        mappedByModuleId[j].content.push(trainingContent[i]);
                    }
                }
            } else {
                mappedByModuleId.push({
                    id: searchModuleId,
                    content: [trainingContent[i]]
                });
            }
        }

        const finalMapping = [];

        for (let i = 0; i < mappedByModuleId.length; i++) {
            const { content } = mappedByModuleId[i];
            const mapping = accessMapping(content[0].s_access_type, content);
            finalMapping.push(...mapping);
        }

        return finalMapping;
    }

    return (
        <AppLayout>
            <div className={`card queue-card-container`} style={{backgroundColor: 'white', height: 'calc(100vh - 120px)', overflowY: 'scroll'}}>
                <div className="card-body mb-5 px-4 py-3">
                    <h1>Training Module</h1>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col md={12}>
                                    <Card className='custom-card'>
                                        <CardBody className='py-3 px-5'>
                                                <Row>
                                                    WARNING: This record contains Sensitive Security Information that is controlled under 49 CFR parts 15 and 1520. No part of this record may be disclosed to persons without a "need to know", as defined in 49 CFR parts 15 and 1520, except with the written permission of the Administrator of the Transportation Security Administration or the Secretary of Transportation. Unauthorized release may result in civil penalty or other action. For U.S. government agencies, public disclosure is governed by 5 U.S.C. 552 and 49 CFR parts 15 and 1520.
                                                </Row>
                                                <Row>
                                                    <h4>Training Content:</h4>
                                                </Row>
                                                <Row>
                                                {
                                                    <Table>
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th>Type</th>
                                                                <th>Name</th>               
                                                                <th>Completed</th>
                                                                <th>Score</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className={'table-row-hover'}>
                                                            {                                        
                                                                resolveTrainingMapping(trainingContent).map((t, i) =>  
                                                                    <tr key={i} onClick={() => handleContent(t)}>
                                                                        <td>{i + 1}</td>
                                                                        <td>{t.s_type === 'QUIZ' ? 'QUIZ' : 'POWERPOINT'}</td>
                                                                        <td>{t.s_name}</td>
                                                                        <td>{t.b_completed && t.b_completed ? 'Yes' : 'No'}</td>
                                                                        <td>{t.f_percent && `${(t.f_percent * 100).toFixed(0)}%`}</td>
                                                                    </tr>
                                                                )
                                                            }
                                                        </tbody>
                                                    </Table>
                                                }
                                                </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>

            <ModalPowerpoint 
                open={modalPowerpointOpen}
                handleModal={setModalPowerpointOpen}
                s_link={powerpointLink}
            />

            <ModalQuiz 
                open={modalQuizOpen}
                handleModal={setModalQuizOpen}
                i_quiz_id={i_quiz_id}
                user={user}
                selectedContent={selectedContent}
                i_training_id={i_training_id}
                createTrainingRecord={createTrainingRecord}
                assignorName={assignorName}
            />



        </AppLayout>
    );
}

export default withRouter(Training);